<template>
  <div class="login_f_box">
    <div class="top_right_box1">
      <!-- 语言切换 -->
      <el-popover
          placement="bottom"
          popper-class="top_user lan_popover"
          width="70"
          v-model="visible_lan"
          trigger="click">
          <span slot="reference">
            <span class="lan_icon" v-if="v_lan=='ch' ">简体中文</span>
            <span class="lan_icon" v-else-if="v_lan=='jp' ">日本語</span>
            <span class="lan_icon" v-else>English</span>
            <i v-if="visible_lan" class="el-icon-caret-top u_r_icon2"></i>
            <i v-else class="el-icon-caret-bottom u_r_icon2"></i>
          </span>
          <div class="u_box">
            <div class="lan_list_item" @click="lang_fun('ch')">简体中文</div>
            <div class="lan_list_item" @click="lang_fun('en')">English</div>
            <div class="lan_list_item" @click="lang_fun('jp')">日本語</div>
          </div>
      </el-popover>
    </div>

    <div class="login">

      <div class="tit_top">
        <img src="../../assets/img/Logo.png" alt="">
      </div>
      <div v-if="login_state==2 && !two_txt_show && pc_app=='app'" style="height:120px;">&nbsp;</div>
      <div class="login_body">
        <!-- 填写信息 -->
        <el-form
          v-if="login_state==1"
          class="form_box"
          label-position="top"
          :model="form"
          @submit.native.prevent
        >
          <el-form-item>
            <div class="form_tit">{{$t('main.text184')}} <span style="font-weight: 700;">Beth!</span></div>
          </el-form-item>
          <el-form-item :label="$t('main.text185')">
            <el-input v-model.trim="form.email"></el-input>
          </el-form-item>
          <el-form-item :label="$t('main.text186')">
            <el-input 
              v-model.trim="form.pwd"
              :type="pwdType == true ? 'password' : 'text'"
            ></el-input>
            <span class="show-pwd" @click="pwdType = !pwdType">
              <img :src="pwdType ? pwd_yes : pwd_no" alt="" />
            </span>

            <div class="for_pwd"><span @click="$router.push('/forget_pwd')">{{$t('main.text187')}}</span></div>
            
          </el-form-item>
          <el-form-item :label="$t('main.text190')">
            <div class="code_w">
              <el-input class="code_w2" v-model.trim="form.code" @keyup.enter.native="confirm_btn"></el-input>
              <div class="code_w3">
                <span @click="createCode">{{code}}</span>
                <img
                  @click="createCode"
                  class="f_icon"
                  src="../../assets/img/flush_icon.png"
                  alt=""
                />
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button class="login_btn" @click="confirm_btn">{{ $t("main.text38") }}</el-button>
          </el-form-item>
        </el-form>
        
        <!-- 扫码 -->
        <div v-else-if="login_state==2" class="ewm_box">
          <template v-if="two_txt_show">
            <div class="ewm_box1">{{$t("main.text673")}}</div>
            <div class="ewm_box2">{{$t("main.text674")}}</div>
            <div class="ewm_box3">
              <div class="ewm_ody" ref="qrcode1"></div>
            </div>
            <div class="qrcode_secret">
              <!-- <span>{{ google_secret }}</span> -->
              <span>{{ google_secret.substr(0,10) }}</span>
              <span>......</span>
              <span>{{ google_secret.substr(-8,10) }}</span>
              <img src="../../assets/img/copy_icon.png" @click="copy_api(google_secret)" alt="">
            </div>
            <div class="ewm_box4">{{$t("main.text675")}}</div>
          </template>
          <!-- <div>
            <el-button class="login_btn" @click="login_state=3">{{ $t("main.text394") }}</el-button>
          </div> -->

          <div>
            <div class="label_box">{{ $t('main.text677') }}</div>
            <el-input v-model.trim="google_code" @keyup.enter.native="login_btn_sbmt"></el-input>
          </div>
          
          <div style="margin-top: 15px;">
            <el-button class="login_btn" v-if="google_code&&google_code.length==6 " @click="login_btn_sbmt">{{ $t("main.text38") }}</el-button>
            <el-button class="login_btn" v-else>{{ $t("main.text38") }}</el-button>
          </div>

        </div>
        
        <!-- 扫码之后 六位数密码 -->
        <!-- <div v-else-if="login_state==3">
          <el-form
          class="form_box"
          label-position="top"
          @submit.native.prevent
        >
          <el-form-item>
            <div class="form_tit">{{$t('main.text676')}}</div>
          </el-form-item>

          <el-form-item :label="$t('main.text677')">
            <el-input v-model.trim="google_code" @keyup.enter.native="login_btn_sbmt"></el-input>
          </el-form-item>
          
          <el-form-item>
            <el-button class="login_btn" v-if="google_code&&google_code.length==6 " @click="login_btn_sbmt">{{ $t("main.text38") }}</el-button>
            <el-button class="login_btn" v-else>{{ $t("main.text38") }}</el-button>
          </el-form-item>
        </el-form>
        </div> -->

      </div>

      <div class="btm_txt">{{$t('main.bt1')}}</div>
      
    </div>
  </div>

</template>

<script>
import {login,account_login,account_verify} from '@/api/api'
import md5 from 'js-md5';
import QRCode from "qrcodejs2";

export default {
  data() {
    return {
      pc_app: this.pcormove._isMobile(),
      pwd_yes: require("../../assets/img/eye_no_b.png"),
      pwd_no: require("../../assets/img/eye_yes_b.png"),
      pwdType: true,
      code: "",
      form: {
        email:'',
        pwd:'',
        code:'',
      },
      email_addr:'',
      visible_lan:false,

      login_state:1,//1 2 3
      Google_data:{
        isBind:0
      },
      verify_type:"",//	Number	1绑定验证 0验证
      google_secret:"",//	String	谷歌密钥
      google_code:"",//	String	谷歌验证码
      two_txt_show:false,
    };
  },
  watch:{
    
  },
  mounted() {
    if (window.fcWidget && window.fcWidget.isInitialized()) {
      window.fcWidget.destroy();
    }
    this.createCode();
  },
  methods: {
    createCode() {
      var code = "";
      var codeLength = 4;
      var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
      for (var i = 0; i < codeLength; i++) {
        var index = Math.floor(Math.random() * 9);
        code += random[index];
      }
      this.code = code;
    },
    confirm_btn(){
      if(this.form.email==''){
        this.message.ismessage('error',this.$t('main.text191'));
        return false;
      }
      if(this.form.pwd==''){
        this.message.ismessage('error',this.$t('main.text192'));
        return false;
      }
      if(this.form.code==''){
        this.message.ismessage('error',this.$t('main.text193'));
        return false;
      }
      if(this.form.code!=this.code){
        this.message.ismessage('error',this.$t('main.text194'));
        return false;
      }

      // var reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,12}$/;
      // if(!reg.test(this.form.pwd)){
      //   this.message.ismessage('error','密码只能为大写字母+小写字母+数字的8至12位字符组合');
      //   this.message.ismessage('error',this.$t('main.text246'));
      //   return false;
      // }

      // 验证谷歌令牌
      account_login({
        password:md5(this.form.pwd),
        email:this.form.email
      }).then(res=>{
        if(res.data.code==200){
          this.Google_data=res.data.data;
          if(res.data.data.userid){
            sessionStorage.setItem("userid",res.data.data.userid);
          }
          if(res.data.data.token){
            sessionStorage.setItem("token",res.data.data.token);
          }
          this.google_secret=res.data.data.google_secret;
          if(res.data.data.isBind==0){
            this.login_state=2;
            this.two_txt_show=true;
            this.$nextTick(function(){
              this.qrcodeRender();
            })
          }else if(res.data.data.isBind==1){
            this.login_state=2;
            this.two_txt_show=false;
          }
          
        }else{
          return this.message.ismessage('error',res.data.msg);
        }
      })

    },
    lang_fun(v) {
      localStorage.setItem("language", v);
      setTimeout(() => {
        location.reload();
      }, 100);
    },
    qrcodeRender() {
      this.$refs.qrcode1.innerHTML = "";
      new QRCode(this.$refs.qrcode1, {
          width: 260,//220
          height: 260,
          text: `otpauth://totp/${this.form.email}@${window.location.hostname}?secret=${this.google_secret}`, // 二维码内容
          colorDark: "#000",//#000 #fff
          colorLight: "#fff",//transparent
          correctLevel: QRCode.CorrectLevel.H,
      });
      
    },
    api_login(){
      // email	String	邮箱
      // password	String	密码 md5
      login({
        email:this.form.email,
        password:md5(this.form.pwd)
      }).then(res=>{
        if (res.data.code==200) {
          this.message.ismessage('success',this.$t('main.text195'));
          if(!localStorage.getItem("language")) {
            localStorage.setItem("language", 'en');
          }
          localStorage.setItem("phone_cc", res.data.data.phone_cc);
          localStorage.setItem("phone_num", res.data.data.phone_num);
          sessionStorage.setItem("token", res.data.data.token);
          sessionStorage.setItem("userid", res.data.data.userid);
          sessionStorage.setItem("username", res.data.data.username);

          // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
          // 4审核通过 路由才能跳转
          sessionStorage.setItem("kyc_status", res.data.data.kyc_status);
          sessionStorage.setItem("u_email", res.data.data.email);
          this.$router.push("/");

        }else{
          // this.$message.closeAll();
          // this.$message.error(res.data.msg);
          this.message.ismessage('error',res.data.msg);
        }
      })
    },
    login_btn_sbmt(){
      if(this.google_code==''){
        return this.message.ismessage('error',this.$t('main.text677'));
      }
      // 谷歌令牌 登陆
      account_verify({
        password:md5(this.form.pwd),
        email:this.form.email,
        verify_type: this.Google_data.isBind==0?'1':(this.Google_data.isBind==1?'0':''),
        google_secret:this.google_secret,
        google_code: (this.google_code+"")
      }).then(res=>{
        if(res.data.code==200){
          this.message.ismessage('success',this.$t('main.text195'));
          if(!localStorage.getItem("language")) {
            localStorage.setItem("language", 'en');
          }
          localStorage.setItem("phone_cc", res.data.data.phone_cc);
          localStorage.setItem("phone_num", res.data.data.phone_num);
          sessionStorage.setItem("userid", res.data.data.userid);
          sessionStorage.setItem("username", res.data.data.username);
          sessionStorage.setItem("token", res.data.data.token);
          sessionStorage.setItem("kyc_status", res.data.data.kyc_status);
          sessionStorage.setItem("u_email", res.data.data.email);
          sessionStorage.setItem('is_google',true)
          this.$router.push("/");
          
        }else{
          return this.message.ismessage('error',res.data.msg);
        }
      })

    },
    //复制
    copy_api(v) {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", v);
      input.select();
      if (document.execCommand("copy")) {
          document.execCommand("copy");
      }
      document.body.removeChild(input);
      this.message.ismessage('success',this.$t('main.text297'));
    },

  },
};
</script>

<style scoped>
.login_f_box{
  position: relative;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  background: url(../../assets/img/login_lift_bgc_bgc.png) no-repeat;
  background-size: cover;
  position: relative;
}
.login {
  position: absolute;
  width: 476px;
  min-height: 50%;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.login_body{
  background: #232A36;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px 28px 40px;
}
.tit_top{
  text-align: center;
}
.tit_top img{
  width: 190px;
  /* margin-bottom: 15px; */
}
.login >>> .el-form--label-top .el-form-item__label{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #BBBBBB;
}
.login >>> .el-input__inner{
  background: #333A47;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 4px;
  color: #fff;
}
.ewm_box{
  font-style: normal;
  font-weight: 700;
  text-align: center;
  color: #FFFFFF;
}
.ewm_box1{
  font-weight: 700;
  font-size: 22px;
  line-height: 26px;
  margin-bottom: 8px;
}
.ewm_box2{
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #BBBBBB;
  margin-bottom: 28px;
}
.ewm_box4{
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #BBBBBB;
  margin: 28px 0;
  word-break: break-word;
}
.ewm_ody{
  display: inline-block;
  border: 2px solid #fff;
}



.form_tit {
  font-style: normal;
  /* font-weight: 700; */
  font-size: 22px;
  text-align: center;
  color: #FFFFFF;
}
.for_pwd {
  text-align: right;
  color: #00C18E;
  font-size: 15px;
}
.for_pwd span{
  cursor: pointer;
  border-bottom: 1.5px solid #00C18E;
}
.code_w {
  display: flex;
}
.code_w2 {
  width: 60%;
}
.code_w3 {
  margin-left: 16px;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 4px;
  flex: 1;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #333A47;
}
.code_w3 span {
  background: #000;
  height: 85%;
  line-height: 32px;
  border-radius: 5px;
  padding: 0 12px;
  font-size: 18px;
  display: inline-block;
  letter-spacing: 8px;
}
.login_btn,
.login_btn:hover {
  width: 100%;
  height: 42px;
  background: #00C18E;
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-color: #00C18E;
  border-radius: 4px;
  color: #191E29;
  margin-top: 10px;
  font-size: 15px;
}

.f_icon {
  width: 18px;
  vertical-align: middle;
  /* margin-left: 10px; */
  cursor: pointer;
}
/* ------ */
.dlg_body{
    background: #041E35;
    color: #fff;  
}
.d_body{
    box-sizing: border-box;
    padding: 40px 0;
    max-width: 420px;
    margin: auto;
}
.dlg_u_box{
    display: flex;
    align-items: center;
}
.dlg_u1{
    width: 100px;
    height: 100px;
    border: 2px solid #DEB981;
    border-radius: 50%;
}
.dlg_u2,.dlg_u2:hover{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border: none;
    border-radius: 4px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 18px;
    color: #04182A;
    margin-left: 40px;
    margin-bottom: 8px;
}
.dlg_u3{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    color: #FFFFFF;
    margin-left: 40px;
}
.dlg_form{
    margin-top: 25px;
}
.dlg_form >>> .el-form-item__label{
    line-height: 30px;
    color: #fff;
    padding: 0;
}
.cancel_btn{
    color: #F1C788;
    border-color: #F1C788;
    background: transparent;
}
.confirm_btn{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    color: #04182A;
    border-color: #F1C788;
    margin-left: 20px;
}

.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}
.login >>> .el-form-item {
  margin-bottom: 20px;
}

/* 语言切换 */
.lan_icon{
  width: 28px;
  height: 28px;
  vertical-align: middle;
  cursor: pointer;
  color: #00C18E;
}
.top_right_box1{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  top: 36px;
  right: 45px;
  z-index: 1;
}
.u_r_icon2{
  margin-left: 8px;
  cursor: pointer;
  margin-top: 5px;
  color: #fff;
  color: #00C18E;
}
.lan_list_item{
  cursor: pointer;
  /* width: 28px;
  height: 28px; */
  margin: 10px auto;
  display: block;
}
.head_title2{
  /* max-width: 70%; */
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.top_right_box1 > span{
  border: 1px solid rgba(49, 72, 105, 0.2);
  box-sizing: border-box;
  padding: 2px 6px;
  border-radius: 4px;
}
.btm_txt{
  font-style: normal;
  font-size: 20px;
  text-align: center;
  color: #FFFFFF;
  margin-top: 15px;
}
.qrcode_secret{
  font-size: 15px;
  line-height: 18px;
  color: #BBBBBB;
  margin: 28px 0;
}
.qrcode_secret span{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 68%;
  display: inline-block;
}
.qrcode_secret img{
  cursor: pointer;
  margin-left: 5px;
  width: 15px;
}
.label_box{
  text-align: left;
  font-size: 12px;
  margin-bottom: 9px;
  color: #959595;
}

/* ------ */
</style>

<style>
/* 语言 */
.top_user{
  color: #fff;
  font-size: 15px;
  background: #03101C;
  box-shadow: 0px 4px 8px #03101C;
  border-radius: 16px;
  border: none;
}
.top_user[x-placement^=bottom] .popper__arrow,
.top_user[x-placement^=bottom] .popper__arrow::after{
  display: none;
  border-bottom-color: transparent;
}
.top_user .popper__arrow{
  display: none;
}
.lan_popover{
  min-width: 70px;
  /* transform: translateX(-12px); */
}
/* ---- */
</style>

<style scoped>
  /* 手机端 */
@media screen and (max-height: 920px) {
  .login{
    left: 50%;
    top: 0;
    transform: translate(-50%,0);
  }
  .login_f_box{
    height: 925px !important;
  }
}
@media screen and (max-width: 850px) {
  .login{
    width: 100%;
  }
  .tit_top img {
    width: 135px;
    /* margin-bottom: 10px; */
  }
  .btm_txt {
    margin-top: 16px;
  }
  .login_f_box {
    height: 730px !important;
  }
}

</style>

<style>
/* .dlg{
    background:rgb(4, 23, 40) !important;
    color: #fff;
} */
.dlg .el-dialog__title{
    color: #fff;
}
.dlg .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
}
.dlg .el-dialog__body {
    padding: 30px 0;
}
</style>